import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaUserTie, FaPhone } from 'react-icons/fa';
import { teamData } from '../data/teamData';
import './Team.css';

const Team = () => {
    return (
        <section className="team-section">
            <div className="team-container">
                {/* Header */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="team-header"
                >
                    <span className="team-badge">Our Team</span>
                    <h2 className="team-title">
                        Meet Our Expert Team
                    </h2>
                    <p className="team-subtitle">
                        Dedicated professionals committed to making your study abroad dreams a reality
                    </p>
                </motion.div>

                {/* Team Grid */}
                <div className="team-grid">
                    {teamData.map((member, index) => (
                        <motion.div
                            key={member.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: index * 0.2 }}
                            viewport={{ once: true }}
                            className="team-card"
                        >
                            {/* Card Background Gradient */}
                            <div className="team-card-bg"></div>

                            {/* Member Image or Placeholder */}
                            <div className="member-image-wrapper">
                                {member.image ? (
                                    <img
                                        src={member.image}
                                        alt={member.name}
                                        className="member-image"
                                    />
                                ) : (
                                    <div className="member-placeholder">
                                        <FaUserTie className="placeholder-icon" />
                                    </div>
                                )}
                            </div>

                            {/* Member Info */}
                            <div className="member-info">
                                <h3 className="member-name">{member.name}</h3>
                                <p className="member-position">{member.position}</p>
                                <p className="member-company">{member.company}</p>

                                {member.description && (
                                    <p className="member-description">{member.description}</p>
                                )}

                                {/* Contact Buttons */}
                                <div className="contact-buttons">
                                    <a
                                        href={`tel:${member.phone}`}
                                        className="contact-btn phone-btn"
                                    >
                                        <FaPhone />
                                        <span>Call</span>
                                    </a>
                                    <a
                                        href={`mailto:${member.email}`}
                                        className="contact-btn email-btn"
                                    >
                                        <FaEnvelope />
                                        <span>Email</span>
                                    </a>
                                </div>
                            </div>

                            {/* Decorative Elements */}
                            <div className="card-decoration card-decoration-1"></div>
                            <div className="card-decoration card-decoration-2"></div>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Background Elements */}
            <div className="team-bg-elements">
                <div className="bg-shape bg-shape-1"></div>
                <div className="bg-shape bg-shape-2"></div>
            </div>
        </section>
    );
};

export default Team;
